import React from 'react';
import { HelpCircle } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const VenueFAQ = React.memo(({ venue }) => {
  if (!venue.faqs || venue.faqs.length === 0) return null;

  return (
    <div className="bg-white rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden">
      <div className="p-6 sm:p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="bg-gradient-to-r from-purple-500 to-pink-600 p-3 rounded-2xl shadow-lg">
            <HelpCircle className="w-6 h-6 text-white" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-gray-900">Sıkça Sorulan Sorular</h2>
            <p className="text-sm text-gray-500">Merak ettikleriniz</p>
          </div>
        </div>
        <Accordion type="single" collapsible className="w-full">
          {venue.faqs.map((faq, index) => (
            <AccordionItem key={faq.id || index} value={`item-${index}`} className="border-b border-gray-200 last:border-b-0">
              <AccordionTrigger className="text-left py-4 hover:no-underline">
                <span className="text-base font-semibold text-gray-900 pr-4">{faq.question}</span>
              </AccordionTrigger>
              <AccordionContent className="pt-2 pb-4">
                <p className="text-gray-700 leading-relaxed whitespace-pre-line">{faq.answer}</p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
});

VenueFAQ.displayName = 'VenueFAQ';
export default VenueFAQ;
